module.exports = __webpack_public_path__ + "img/icon_minus_default.d052f8b2.svg";